<template>
<div class="glo-table-wrapper">
    <!-- 表格头部 -->
    <div class="glo-table-wrapper__header" ref='header' v-if='$slots.header || hasSearch'>
        <div v-if='hasSearch' class="glo-table-wrapper__search" style="text-align: right">
            <el-input v-model="searchName" @keyup.enter.native="handleEnter" @change='handleSearchChange' size='small' :placeholder="placeholder">
                <el-button @click='handleClick' type="primary" slot="append" size='small' icon="el-icon-search">
                </el-button>
            </el-input>
        </div>
        <div class="glo-table-wrapper__form" v-if="$slots.header">
            <slot name='header'></slot>
        </div>

    </div>
    <!-- 表格内容 -->
    <div class="glo-table-wrapper__body" ref='body'>
        <el-table stripe style="width: 100%" ref='table' :height='isFull ? bodyHeight + "px": height' :data="flatData(data)" v-bind='$attrs' v-on='$listeners' :row-key='rowKey'  v-loading="loading" :element-loading-text="loadingText" :header-row-class-name="headerRowClassName">

            <template v-if="empty" slot="empty">
                {{emptyValue}}
            </template>
            <template v-if="!customScroll">
                   <el-table-column v-if='type && type !=="radio"' align='center' width="55" :type="type" :label='label' :selectable="type === 'selection' ? selectable : ()=> true" :reserve-selection='type === "selection"'  :fixed="fixedLeft">
            </el-table-column>

            <el-table-column v-if='type === "radio"' align='center' width="55" :type="type" label='单选' :fixed="fixedLeft">
                <template slot-scope="scope">
                    <el-radio v-model="radioValue" @change='handleRadioChange(scope.row[radioProp], scope.row)' :label='scope.row[radioProp]' :disabled="selectable ? selectable(scope.row[radioProp]): scope.row.disabled"></el-radio>
                </template>

            </el-table-column>

            <el-table-column v-if='order' label='序号' width="55" align='center' :fixed="fixedLeft">
                <template slot-scope="scope">
                    {{scope.$index + 1}}
                </template>
            </el-table-column>

            <!-- 表格主要内容 -->
            <g-column v-for='(column, index) in columns' :show-overflow-tooltip='column.showOverflowTooltip===false?false:true' :key='column.prop + column.label + index' v-bind='column' :align='column.align || "center"'>

            </g-column>

            <el-table-column v-if='panel && Object.keys(panel).length' :width='panelWidth' label='操作' :fixed="fixedRight?'right':false" :align='operationAlign'>
                <template slot-scope="scope">
                    <el-button-group class="glo-table__panel">
                        <span v-for='btn in scope.row.pageOpers || []' :key='btn.code'>
                            <el-button v-if="panel[btn.code]"  v-bind='filterPanel(btn)' @click="handleButtonClick(btn, scope)" type="text">
                                {{btn.title}}
                            </el-button>
                        </span>
                    </el-button-group>
                </template>
            </el-table-column>
            </template>

            <slot></slot>
        </el-table>
    </div>
    <!-- 表格底部 默认分页 -->

    <div class="glo-table-wrapper__footer" v-if='isPagination'>
        <el-pagination class="glo-pagination" @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="pagination.count == 0 ? 0 : pagination.page" :page-sizes="pageSizes" :page-size="pagination.pageSize" :total="pagination.count || pagination.total || 0" layout="total, sizes, prev, pager, next, jumper" />
    </div>
</div>
</template>

<script>
import {
    debounce
} from '@/extend/debounce'

const format = function (scope, column) {
    return scope.row[column.prop || column.property]
};

export default {
    name: 'GTable',

    inheritAttrs: false,

    model: {
        prop: 'pagination',
        event: 'change'
    },

    data() {
        return {
            bodyHeight: '',
            buttonGroup: [],
            searchName: '',
            radioValue: ''
        }
    },

    watch: {
        searchName(val) {
            this.hasSearch && !val && this.$emit(
                'change', {
                    ...this.pagination,
                    page: 1,
                    searchName: val
                }
            )
        },

        data(tableData) {
            if (this.searchName) return;

            !tableData.length &&
                this.pagination.page > 1 &&
                this.handleCurrentChange(
                    this.pagination.page - 1
                );
        },
        loading(val){
            console.log(val)
            this.getLoading=val
        }
    },

    components: {
        GCell: {
            functional: true,
            props: {
                scope: Object,
                column: {
                    type: Object,
                    required: true,
                    default () {
                        return {}
                    }
                }
            },
            render: (h, ctx) => {
                const {
                    scope,
                    column
                } = ctx.props;
                const {
                    render,
                    formatter = format,
                    children = []
                } = column;
                return typeof render === 'function' ?
                    render(h, scope, column) :
                    h('span', null, formatter(scope, column) || '--')
            }
        },

        GColumn: {
            functional: true,
            render(h, ctx) {
                const children = ctx.props.children || [];
                const renderCell = function render(scope, column) {
                    return h(
                        'g-cell', {
                            props: {
                                scope,
                                column
                            }
                        },
                        []
                    )
                }
                return h(
                    'el-table-column', {
                        ...ctx,
                        scopedSlots: {
                            default (scope) {
                                return renderCell(scope, ctx.props)
                            }
                        }
                    },

                    children.length && children.map(item => h(
                        'g-column', {
                            props: item,
                            scopedSlots: {
                                default (scope) {
                                    return renderCell(scope, item);
                                }
                            }
                        }
                    ))
                )
            }
        }
    },

    props: {
        loadingText:{
            type:String,
            default:'加载中'
        },
        fixedLeft:{//是否左浮动定位
            type:Boolean,
            default:false
        },
        fixedRight:{//是否右浮动定位
            type:Boolean,
            default:false
        },
        operationAlign:{//操作列对齐方式
            type:String,
            default:'left'
        },
        customScroll:{//自定义左右滚动效果，true:页面单独渲染tabel  false:默认渲染
            type:Boolean,
            default:false
        },
        empty: {//是否显示自定义提示
            type: Boolean,
            default:false
        },
        emptyValue: { //自动定义提示内容
            type: String,
            default:"暂无数据"
        },
        // 列配置项
        columns: {
            type: Array,
            default () {
                return []
            },
            required: true
        },

        // 复选框必选参数
        rowKey: {
            type: String,
            default: 'index'
        },

        radioProp: String,
        order: {
            type: Boolean,
            default: false
        },

        hasSearch: {
            type: Boolean,
            default: false
        },

        placeholder: {
            type: String,
            default: '请输入'
        },

        selectable: Function,

        height: [String, Number],

        // 是否一屏
        isFull: {
            type: Boolean,
            default: true
        },

        // 表格栏首列类型
        type: String,

        // index
        label: {
            type: String,
            default: '序号'
        },

        // 操作按钮栏宽度
        panelWidth: {
            type: String,
            default: '150px'
        },

        // 表格操作栏按钮
        panel: {
            type: Object,
            default () {
                return {}
            }
        },

        // 表格数据
        data: {
            type: Array,
            default () {
                return []
            },
            required: true
        },

        // 是否显示分页
        isPagination: {
            type: Boolean,
            default: true
        },
        // 每页显示
        pageSizes: {
            type: Array,
            default () {
                return [10, 20, 30, 100]
            }
        },

        // 分页信息
        pagination: {
            type: Object,
            default () {
                return {
                    pageSize: 10,
                    total: 0,
                    page: 1,
                    count: 0
                }
            }
        },
        loading:{
            type:Boolean,
            default:false
        },
        disabledCheckboxStatus:{
            type: Boolean,
            default: false
        }
    },

    methods: {
        headerRowClassName({row, rowIndex}) {
            if (this.disabledCheckboxStatus) {
                return "disableItem";
            }
            return "";
        },
        handleRadioChange(val, row) {
            this.$emit('radio-change', val, row)
        },

        clearRadio() {
            this.radioValue = '';
        },

        filterPanel(option = {}) {
            const {
                code,
                text,
                onClick,
                title,
                pageOpers,
                ...prop
            } = option;
            return prop
        },

        handleSizeChange(num) {
            this.$emit('change', {
                ...this.pagination,
                searchName: this.searchName,
                pageSize: num
            })
        },

        handleCurrentChange(num) {
            this.$emit('change', {
                ...this.pagination,
                searchName: this.searchName,
                page: num
            })
        },

        handleSearchChange(searchName) {
            this.searchName = searchName;
            this.$emit('change', {
                ...this.pagination,
                page: 1,
                searchName
            })
        },
        handleButtonClick(it, scope) {
            const panel = this.panel;
            if (!panel.hasOwnProperty(it.code)) {
                return console.error(`属性为${it.code}的按钮权限未注册`);
            }
            const callback = typeof panel[it.code] === 'function' ? panel[it.code] : panel[it.code].onClick;
            typeof callback === 'function' && callback(scope, this)
        },

        onResize() {
            if (!this.isFull) return;
            this.bodyHeight = this.$refs.body.offsetHeight;
        },

        initReset() {
            if (!this.isFull) return;
            this.handleResize = debounce(this.onResize, 60);
        },

        flatData(arr = []) {
            return arr.map(item => {
                const {
                    data,
                    pageOpers
                } = item;
                return (data ? {
                    ...data,
                    pageOpers
                } : item) || {};
            })
        },

        handleEnter() {
            this.$emit(
                'enter', {
                    ...this.pagination,
                    page: 1,
                    searchName: this.searchName
                }
            );
        },

        handleClick() {
            this.$emit(
                'search-icon-click', {
                    ...this.pagination,
                    page: 1,
                    searchName: this.searchName
                }
            )
        }
    },

    created() {
        this.initReset();
    },

    mounted() {
        if (this.isFull) {
            this.onResize();
            window.addEventListener('resize', this.handleResize)
        }
    },

    beforeDestroy() {
        this.isFull && window.removeEventListener('resize', this.handleResize)
    }
}
</script>

<style lang="scss" scoped>
.glo-table-wrapper {
    height: 100%;
    background: #fff;
    box-sizing: border-box;
    // padding: 10px;

    .glo-table-wrapper__header {
      overflow: hidden;
        padding: 10px 0;
        padding-top: 0;
    }

    .glo-table-wrapper__search {
        float: right;
        text-align: right;
        // margin-right: 3px;
        margin-left: 5px;
    }

    .glo-table-wrapper__form {
        overflow: hidden;

        & /deep/ .el-form-item {
            margin-bottom: 0;
        }
    }

    .glo-table-wrapper__body {
        height: calc(100% - 100px);

        // .el-table{
        //     height: 100%!important;
        //     min-height: 500px;
        // }
        & .el-button {
            margin-right: 3px;
        }

        & .el-button:last-child {
            margin-right: 0;
        }

        & /deep/ .el-radio {
            margin-right: 0;

            & .el-radio__label {
                display: none;
            }
        }

        & /deep/ .el-table__body-wrapper {
            -ms-overflow-style: scrollbar;
        }
        & /deep/ .el-table__empty-block {
            min-height: 150px !important;
        }
    }

    .glo-table-wrapper__footer {
        height: 50px;
        line-height: 50px;
        padding-top: 14px;
        text-align: center;
    }
}

.glo-pagination {
    display: inline-block;
    padding: 0;

}
.el-table>>> .disableItem th:first-child .cell .el-checkbox>span>.el-checkbox__inner{
    background-color: #efefef !important;
    border-color: #D9D9D9 !important;
    cursor: not-allowed !important;
}
.el-table>>> .disableItem th:first-child .cell .el-checkbox>span>.el-checkbox__inner::after{
    border-color: #C0C4CC !important;
}
</style>



// WEBPACK FOOTER //
// src/components/table.vue